import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { GET_GROUPS } from '../../../graphql/queries';
import { useStateContext } from '../../../context/state';
import DialogBox from '../../../components/DialogBox';
import FilterBar from '../../../components/FilterBar';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { getErrorMsg, truncateString } from '../../../utils/helperFuncs';
import { useAuthContext } from '../../../context/auth';

import {
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Divider,
  Typography,
  Button
} from '@material-ui/core';
import { useChatListStyles } from '../../../styles/muiStyles';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import GroupIcon from '@material-ui/icons/Group';
import CreateGroup from './CreateGroup';

const Groups = () => {
  const classes = useChatListStyles();
  const [createGroupModal, setCreateGroupModal] = useState(false);
  const { selectedChat, selectChat, notify } = useStateContext();
  const [filterValue, setFilterValue] = useState('');
  const { user } = useAuthContext();
  const role = ['admin', 'faculty']
  const { data: groupData, loading: loadingGroups } = useQuery(GET_GROUPS, {
    onError: (err) => {
      notify(getErrorMsg(err), 'error');
    },
  });

  if (loadingGroups || !groupData) {
    return <LoadingSpinner />;
  }

  return (
    <div className={classes.root}>
      <div className={classes.list}>
        <div className={classes.wrapper}>
          <FilterBar
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            placeholder="Search groups"
          />
        </div>
        <div className={classes.wrapper}>
        {(role.includes(user.role)) &&(
          <DialogBox
            title="Create A Group"
            modalOpen={createGroupModal}
            setModalOpen={setCreateGroupModal}
            triggerButton={ 
              <Button
                color="primary"
                variant="contained"
                size="small"
                fullWidth
                onClick={() => setCreateGroupModal(true)}
                startIcon={<GroupAddIcon />}
              >
                Create Group
              </Button>
            }
            children={
              <CreateGroup closeModal={() => setCreateGroupModal(false)} />
            }
          />
        )}
        
        
          </div>
        {groupData && groupData.getGroups.length === 0 && (
          <Typography
            variant="subtitle1"
            color="secondary"
            className={classes.infoText}
          >
            You've not been added to any groups.
          </Typography>
        )}
        <Divider />
        {groupData &&
          groupData.getGroups
            .filter((group) =>
              group.name.toLowerCase().includes(filterValue.toLowerCase())
            )
            .map((group) => (
              <div key={group.id}>
                <ListItem
                  className={classes.listItem}
                  button
                  onClick={() => selectChat(group, 'group')}
                  selected={
                    selectedChat?.chatType === 'group' &&
                    group.id === selectedChat.chatData.id
                  }
                >
                  <ListItemAvatar>
                    <Avatar
                    src={`https://avatars.dicebear.com/api/initials/${group.name}.svg?backgroundColorLevel=300&fontSize=35`}
                    />
                  </ListItemAvatar>
                  <GroupIcon color='primary' fontSize='small'style={{marginRight:'5px'}} />
                  <ListItemText primary={truncateString( group.name, 25)} />
                </ListItem>
                <Divider />
              </div>
            ))}
      </div>
    </div>
  );
};

export default Groups;
